module.exports = __webpack_public_path__ + "static/media/patient_online.4dec1a21.png";